export const deleteSkill = async (functionParameters = {}) => {

    const deleteFromServer = (await import(/* webpackPrefetch: true */ `../../delete/deleteFromServer`)).deleteFromServer;

    functionParameters["clickWhenDone"] = "skills";

    return await deleteFromServer(functionParameters);
};

